import React from "react";
import { useBranding } from "@/lib/branding";

export const UD_SEAL = "https://customer-assets-wrfwihn1.emergentagent.net/job_alumni-hub-101/artifacts/n52mfin2_image.png";
export const UD_URL = "https://udallas.edu/";

export const Seal = ({ className = "h-10 w-10", bg = "bg-white", padding = "p-0.5", testid, link = true }) => {
  const b = useBranding();
  const logo = b.logo_primary;
  const url = b.university_url || UD_URL;
  const circle = (
    <div className={`${className} rounded-full ${bg} flex items-center justify-center ${padding} shrink-0 overflow-hidden`}>
      {logo ? <img src={logo} alt={`${b.university_name || "University"} seal`} className="h-full w-full object-contain" /> : <span className="font-serif text-secondary text-sm">{(b.university_name || "U").slice(0, 1)}</span>}
    </div>
  );
  if (!link) return <div data-testid={testid}>{circle}</div>;
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" title={`Visit ${b.university_name || "University"}`} data-testid={testid} className="inline-flex transition-transform hover:scale-105">
      {circle}
    </a>
  );
};
